/* ================================================================
   HERO SCROLL EXIT — RAF loop continuo (NO depende de scroll events)
   ================================================================ */
(function(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.innerWidth < 769) return;

  function setup() {
    var hero = document.querySelector('.nm-hero');
    if (!hero) return;
    var words = hero.querySelectorAll('.nm-h-hero .nm-word');
    if (!words.length) {
      setTimeout(setup, 200);
      return;
    }

    var dirs = [
      {x:-320,y:-180,r:-12},{x:320,y:-130,r:10},
      {x:-240,y:280,r:-18},{x:300,y:240,r:14},
      {x:-380,y:60,r:-8},{x:360,y:-280,r:18},
      {x:-180,y:-320,r:-6},{x:240,y:320,r:16}
    ];
    words.forEach(function(w,i){
      var d = dirs[i%dirs.length];
      w.dataset.exitx = d.x;
      w.dataset.exity = d.y;
      w.dataset.exitr = d.r;
    });

    var lead = hero.querySelector('.nm-hero-lead');
    var eyebrow = hero.querySelector('.nm-hero-eyebrow-light');
    var ctaRow = hero.querySelector('.nm-hero-cta-row');
    var fineprint = hero.querySelector('.nm-hero-fineprint');
    var heroBg = hero.querySelector('.nm-hero-bg');
    var supports = [eyebrow, lead, ctaRow, fineprint].filter(Boolean);

    var lastProgress = -1;

    function loop() {
      var rect = hero.getBoundingClientRect();
      var heroH = hero.offsetHeight || 700;
      var progress = Math.max(0, Math.min(1, -rect.top / heroH));

      // Solo actualizar si el progress cambió (perf)
      if (Math.abs(progress - lastProgress) > 0.003) {
        lastProgress = progress;

        words.forEach(function(w){
          if (progress < 0.01) {
            w.style.transform = '';
            w.style.opacity = '';
          } else {
            var x = parseFloat(w.dataset.exitx||0) * progress;
            var y = parseFloat(w.dataset.exity||0) * progress;
            var r = parseFloat(w.dataset.exitr||0) * progress;
            w.style.transform = 'translate('+x+'px,'+y+'px) rotate('+r+'deg)';
            w.style.opacity = Math.max(0, 1 - progress * 1.35);
          }
        });

        supports.forEach(function(el, i){
          if (progress < 0.01) {
            el.style.transform = '';
            el.style.opacity = '';
          } else {
            var op = Math.max(0, 1 - Math.max(0, progress - i*0.05) * 1.6);
            el.style.opacity = op;
            el.style.transform = 'translateY('+(progress*80)+'px)';
          }
        });

        if (heroBg && progress > 0.01) {
          var scale = 1 + progress * 0.08;
          var existing = heroBg.style.transform || '';
          var tMatch = existing.match(/translate3d\(0(?:px)?,\s*(-?\d+(?:\.\d+)?)px/);
          var ty = tMatch ? parseFloat(tMatch[1]) : 0;
          heroBg.style.transform = 'translate3d(0,' + ty + 'px,0) scale(' + scale + ')';
        }
      }

      window.requestAnimationFrame(loop);
    }

    loop();
  }

  setTimeout(setup, 600);
})();